// Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { getAssetUrl } from '../utils/assetUrl';
import { scrollToSection } from '../utils/scrollToSection';

const navLinks = [
  { label: 'The Concept', sectionId: 'concept' },
  { label: 'Intelligence Layer', sectionId: 'features' },
  { label: 'Labor Calculator', sectionId: 'calculator' },
  { label: 'Resources', sectionId: 'resources' },
  { label: 'Take the Audit', sectionId: 'audit' },
];

export function Footer() {
  return (
    <footer className="bg-muted">
      <div className="mx-auto max-w-7xl px-6 py-12 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1: Logo + Tagline */}
          <div>
            <Link to="/" className="flex items-center space-x-2">
              <img src={getAssetUrl('/kinetic-logo-48.png')} alt="Kinetic Guard Logo" className="w-8 h-8" />
              <span className="text-xl font-semibold">Kinetic Guard</span>
            </Link>
            <p className="mt-4 text-sm text-muted-foreground max-w-xs">
              The vendor-agnostic intelligence layer that transforms any video feed into a proactive, autonomous security operation.
            </p>
          </div>

          {/* Column 2: Navigation */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Navigate</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.sectionId}>
                  <button
                    onClick={() => scrollToSection(link.sectionId)}
                    className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Legal */}
          <div>
            <h3 className="text-sm font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <button
                  onClick={() => window.dispatchEvent(new CustomEvent('open-contact-modal'))}
                  className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-border pt-8">
          <p className="text-center text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} Kinetic Guard Technologies, Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
